// extracted by mini-css-extract-plugin
module.exports = {"spinner":"SnakeLoader_spinner__7trcG","rotate":"SnakeLoader_rotate__2JrgX","bright":"SnakeLoader_bright__26R4A"};